<script src="../../store/modules/iam.store.js"></script>
<template>
  <div>
    <v-row>
      <v-col>
        <FlyoutMenuHead :selectedItem="selectedItem" route="devices"/>
        <v-divider/>
        <CustomForm
        :formData="formData" 
        @onAddTag="addNewTag"
        @onSubmit="addDevice" 
        @onClose="() => { this.$router.go(-1) }">
          <!-- Custom Fields Section -->
          <v-row v-if="hasEnabledCustomFields" class="px-4 mt-2">
            <v-col md="8" class="pl-0">
              <div class="pb-4 pl-0">
                <span class="subtitle text-secondary">{{ $t('assets.tabs.custom_fields') }}</span>
              </div>
              <template v-for="n in 8">
                <v-col
                  v-if="deviceForm[`device_custom_${n}_enabled`]"
                  :key="n"
                  cols="12"
                  class="px-0 py-1"
                >
                  <v-text-field
                    v-model="deviceForm[`device_custom_${n}`]"
                    :label="deviceForm[`device_custom_${n}_alias`]"
                    :error-messages="fieldErrors[`device_custom_${n}`] || []"
                    @input="$set(fieldErrors, `device_custom_${n}`, [])"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </CustomForm>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import FlyoutMenuHead from "../FlyoutMenuHead";
import CustomForm from "../CustomForm";

export default {
  name: "AddRunner",
  metaInfo: {
    title: "Add Runner",
    meta: [
      {
        name: "description",
        content: "Add a new runner to your space"
      }
    ]
  },
  components: {
    CustomForm,
    FlyoutMenuHead,
  },
  computed: {
    ...mapGetters('devices', ['getSelectedDevice', 'getDeviceCustomFields']),
    hasEnabledCustomFields() {
      return this.getDeviceCustomFields.some(f => f.enabled);
    },
  },
  mounted() {
    this.getSpaceDeviceCustomFields().then(() => {
      const updated = {};
      this.getDeviceCustomFields.forEach(f => {
        updated[`device_custom_${f.index}_enabled`] = f.enabled;
        updated[`device_custom_${f.index}_required`] = f.required;
        updated[`device_custom_${f.index}_alias`] = f.alias || `Custom ${f.index}`;
        updated[`device_custom_${f.index}`] = '';
      });
      this.deviceForm = updated;
    });
  },
  methods: {
    ...mapActions('devices', ['addRunnerDevice', 'getSpaceDeviceCustomFields']),
    ...mapActions({"addTag": "tags/addTag"}),
    addNewTag(tag) {
      this.addTag(tag);
    },
    addDevice(form) {
      this.fieldErrors = {};
      let hasErrors = false;
      for (let i = 1; i <= 8; i++) {
        if (this.deviceForm[`device_custom_${i}_enabled`] && this.deviceForm[`device_custom_${i}_required`] && !this.deviceForm[`device_custom_${i}`]) {
          const alias = this.deviceForm[`device_custom_${i}_alias`] || `Custom Field ${i}`;
          this.$set(this.fieldErrors, `device_custom_${i}`, [`${alias} is required.`]);
          hasErrors = true;
        }
        console.log("ovo je greska", this.fieldErrors);
      }
      if (hasErrors) return;

      const customData = {};
      for (let i = 1; i <= 8; i++) {
        if (this.deviceForm[`device_custom_${i}_enabled`]) {
          customData[`device_custom_${i}`] = this.deviceForm[`device_custom_${i}`];
        }
      }
      this.addRunnerDevice({ ...form, ...customData }).then((response) => {
        this.$router.replace(`/devices/device/view/${response.space_uuid}/${response.uuid}/general`);
      }).catch((err) => {
  if (err.response && err.response.status === 409) {
    const message = err.response.data?.message;

    if (message) {
      const match = message.match(/device_custom_(\d+)/);

      if (match) {
        const field = match[0];

        this.$set(this.fieldErrors, field, [message]);
        return;
      }
    }
  }

  if (err.response && err.response.status === 400) {
    const errData = err.response.data;

    Object.keys(errData).forEach(field => {
      const messages = Array.isArray(errData[field])
        ? errData[field]
        : [String(errData[field])];

      this.$set(this.fieldErrors, field, messages);
    });

    return;
  }

  this.$store.commit('updateAlert', {
    type: 'error',
    shown: true,
    message: 'Failed to add device.'
  });
});
    }
  },
  data: () => ({
    deviceForm: {},
    fieldErrors: {},
    selectedItem: {
      name: "Add New Device",
      subtitle: "Once added, you will be able to connect and manage this device.",
    },
    formData: {
      sections: [{
        title: 'Add New',
        inputs: {
          name: {
            value: "name",
            gridSize: 8,
            type: "text",
            placeholder: "Friendly name for your device",
            label: "Device Name"
          },
          device_class: {
            value: "device_class",
            gridSize: 8,
            type: "select",
            placeholder: "Enter device class property",
            label: "Device class",
            options: {
              items: [
                {name: "Kiosk", value: "kiosk"}, 
                {name: "Retail Pos", value: "retail_pos"}, 
                {name: "Visualization", value: "visualization"}],
              text: "name",
              value: "value"
            }
          },
          location_uuid: {
            value: "location_uuid",
            gridSize: 8,
            type: "select",
            placeholder: "Allocate device to Location",
            label: "Location",
            options: {
              items: [],
              action: "locations/getLocationForm",
              text: "name",
              value: "uuid"
            }
          },
          description: {
            value: "description",
            gridSize: 8,
            type: "textarea",
            placeholder: "Description",
            options: {
              counter: 1000
            }
          },
        }
      },
        {
          title: "Tags",
          inputs: {
            tag_uuids: {
              value: "tag_uuids",
              gridSize: 8,
              type: "tags",
              placeholder: "Edit tags for your device",
              label: "Tags",
              options: {
                items: [],
                action: "tags/getTags",
                actionPayload: "device",
                counter: 20,
                text: "name",
                value: "uuid"
              }
            }
          }
        }],
    }
  }),
};
</script>

<style scoped></style>
